import { Component, computed, inject, TemplateRef, Type } from '@angular/core';
import { NzFlexDirective } from 'ng-zorro-antd/flex';
import { NzHeaderComponent } from 'ng-zorro-antd/layout';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';
import { isNotNil } from 'ng-zorro-antd/core/util';
import { PublicHeaderService } from '@app/layouts/public-main/header.service';

interface Subheader {
  cmp: Type<unknown>;
  tmp: TemplateRef<unknown>;
}

@Component({
  selector: 'math-header',
  imports: [
    NzFlexDirective,
    NzHeaderComponent,
    NgComponentOutlet,
    NgTemplateOutlet,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  public headerService = inject(PublicHeaderService);

  public subheader = computed<Subheader | null>(() => {
    const headerConfig = { ...this.headerService.headerConfig() };
    if (headerConfig?.subheader && isNotNil(headerConfig.subheader)) {
      const isTemplateRef = headerConfig.subheader instanceof TemplateRef;
      return {
        cmp: isTemplateRef ? null : (headerConfig.subheader as Type<unknown>),
        tmp: isTemplateRef
          ? (headerConfig.subheader as TemplateRef<unknown>)
          : null,
      };
    }

    return null;
  });
}
